
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/orlando/karaoke-rental",
      function () {
        return require("private-next-pages/orlando/karaoke-rental.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/orlando/karaoke-rental"])
      });
    }
  